<template>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-center">
            <svg class="h-5 w-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span class="underline">Montant pénalité:</span>
        </div>
        <span class="text-sky">
            {{ formatAmount(generalSettings.amount_penality, currency) }}
        </span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-center">
            <svg class="h-5 w-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span class="underline">Nombre de jours applicables aux pénalités:</span>
        </div>
        <span class="text-sky">{{ generalSettings.penality_number_days }} Jours</span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-center">
            <svg class="h-5 w-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
            </svg>
            <span class="underline">TVA:</span>
        </div>
        <span class="text-sky">{{ generalSettings.tva }}%</span>
    </li>
</template>

<script>
    import CurrencyMixins from '@/Mixins/CurrencyMixins'

    export default {
        props: {
            generalSettings: Object,
            currency: Object
        },

        mixins: [CurrencyMixins],

        mounted() {
            console.log(this.currency)
        },
    }
</script>
